<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!-- <el-form-item label="是否开启" prop="is_coupon">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item> -->
         <el-form-item label="标题" >
        <el-input  v-model="form.title" placeholder="请输入标题" class="max-w460"></el-input>
      </el-form-item>
       <el-form-item label="电话" >
        <el-input v-model="form.mobile" placeholder="请输入电话" class="max-w460"></el-input>
      </el-form-item>
       <el-form-item label="邮箱" >
        <el-input  v-model="form.email" placeholder="请输入邮箱" class="max-w460"></el-input>
      </el-form-item>
       <el-form-item label="地址" >
        <el-input  v-model="form.address" placeholder="请输入地址" class="max-w460"></el-input>
      </el-form-item>
       <el-form-item label="文字">
        <el-input  v-model="form.text" placeholder="请输入文字" class="max-w460"></el-input>
      </el-form-item>
      
          <el-form-item label="小程序二维码">
        <el-button @click="choosewxImg">选择图片</el-button>
        <img class="mt10" v-img-url="form.wx_image" width="200">
      </el-form-item>

             <el-form-item label="文字1">
        <el-input  v-model="form.text1" placeholder="请输入文字1" class="max-w460"></el-input>
      </el-form-item>

     <el-form-item label="公众号二维码" >
        <el-button @click="chooseImg">选择图片</el-button>
        <img class="mt10" v-img-url="form.mp_image" width="200">
      </el-form-item>


      
     <el-form-item label="背景" >
        <el-button @click="choosebjImg">选择图片</el-button>
        <img class="mt10" v-img-url="form.bj_image" width="200">
      </el-form-item>



    </el-form>

    
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
 <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 1 }" @returnImgs="returnImgsFunc"></Upload>
       <Upload v-if="iswxupload" :isupload="isupload" :config="{ total: 1 }" @returnImgs="returnImgsFuncwx"></Upload>
          <Upload v-if="isbjupload" :isupload="isupload" :config="{ total: 1 }" @returnImgs="returnImgsFuncbj"></Upload>
    <!--商品图片组件-->
    <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload> -->
  </div>
</template>
<script>
import Store_hfApi from '@/api/store_hf.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      form: {
        title:"",
        status: false,
        mobile:"",
        email:"",
        address:"",
          mp_image:'',
             wx_image:'',
             text:'',
             text1:"",
      },
      setting: [],
      loading: false,
      isupload:false,
          isupwxload:false,
          iswxupload:false,
             isbjupload:false,
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
       /*选择图片*/
      chooseImg(){
        this.isupload=true;
      },

      /*关闭选择图片*/
      returnImgsFunc(e){
        this.isupload=false;
        this.form.mp_image=e[0].file_path;
      },
   /*选择图片*/
      choosewxImg(){
        this.iswxupload=true;
      },

      /*关闭选择图片*/
      returnImgsFuncwx(e){
        this.iswxupload=false;
        this.form.wx_image=e[0].file_path;
      },

         /*选择图片*/
      choosebjImg(){
        this.isbjupload=true;
      },

      /*关闭选择图片*/
      returnImgsFuncbj(e){
        this.isbjupload=false;
        this.form.bj_image=e[0].file_path;
      },

    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      Store_hfApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values!='[]'){
            self.form = data.data.vars.values;
          }
          
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      Store_hfApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/store_hf/setting/getSetting.vue